/*
 * @Author: Hyman Choi
 * @Date: 2021-01-08 16:06:24
 * @LastEditTime: 2022-01-14 16:51:13
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Siui.Cloud.Medical.Web\src\router\Modules\statistics.js
 */
import Layout from '@/layout'

const statisticsRouter = {
  path: '/statistics_management',
  component: Layout,
  redirect: '/statistics_management/user_statistics',
  name: 'statisticsManagement',
  alwaysShow: true,
  meta: {
    roles: ['超级管理员'],
    title: 'statisticsManagement',
    icon: 'statisticsManagement'
  },
  children: [
    {
      path: 'user_statistics',
      name: 'user_statistics',
      component: () =>
        import('@/views/statisticsManagement/userStatistics/index.vue'),
      meta: {
        roles: ['超级管理员'],
        title: 'userStatistics'
      }
    },
    {
      path: 'integral_statistics',
      name: 'integral_statistics',
      component: () =>
        import('@/views/statisticsManagement/integralStatistics/index'),
      meta: {
        roles: ['超级管理员'],
        title: 'integralStatistics'
      }
    },
    {
      path: 'live_statistics',
      name: 'live_statistics',
      component: () => import('@/views/statisticsManagement/liveStatistics/index'),
      meta: {
        roles: ['超级管理员'],
        title: 'liveStatistics'
      }
    },
    {
      path: 'statistics',
      name: 'statistics',
      component: () => import('@/views/statisticsManagement/statistics/index'),
      meta: {
        roles: ['超级管理员'],
        title: 'statistics'
      }
    }
  ]
}

export default statisticsRouter
